var $checkoutWkForm = $(".js-checkout_wk");

$(function(){
    isSubmitChechkoutWk = false;

    if($checkoutWkForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($checkoutWkForm.find(".js-form_successblock"), 5000);
    }

    $checkoutWkForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

        if(isSubmitChechkoutWk && typeof isSubmitChechkoutWk != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitChechkoutWk = true;

        validSubmit = true;
        errorCount = 0;
        errorBestTexte = false;


        $checkoutWkForm.find(".js-form_input").each(function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $checkoutWkForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorBestTexte = true;
                errorCount++;
            }
        });


        if(validSubmit){
            showLoader();

            requestData = "";
            if(typeof $checkoutWkForm[0] != "undefined"){
                $checkoutWkForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST",
                dataType:"json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmitChechkoutWk = false;

                valid = true;
                $.each(response.errors, function(idPos, errors){
                    if(idPos == "wk"){
                        $(".js-form_block_text").html(errors)
                        valid = false;
                    }else{
                        var errorText = "";
                        $.each(errors, function(key, error){
                            if(error != ""){
                                if(errorText != "") errorText += "<br>";
                                errorText += error
                                valid = false;
                            }

                        });

                        $(".js-produkt_liste_error-" + idPos).html(errorText)
                    }
                });

                if(valid){
                    $checkoutWkForm.trigger('submit');
                }else{
                    formMsgBlockShow($checkoutWkForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitChechkoutWk = false;
            formMsgBlockShow($checkoutWkForm.find(".js-form_errorblock"));
            if(errorBestTexte){
                $(".js-bestaetigungstexte_label").text($(".js-bestaetigungstexte_label").data("label") + " - " + $(".js-bestaetigungstexte_label").data("error")).addClass("form_label_text-error")
            }else{
                $(".js-bestaetigungstexte_label").text($(".js-bestaetigungstexte_label").data("label")).removeClass("form_label_text-error")
            }
            hideLoader();
        }
    });
});